import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.container}>
      <ul>
        <p>Choose purchases</p>
        <li>Mac</li>
        <li>iPad</li>
        <li>iPhone</li>
        <li>Apple Watch</li>
        <li>TV</li>
        <li>Music</li>
        <li>iTunes</li>
        <li>iPadTouch</li>
        <li>Accessories</li>
      </ul>


      <ul>
        <p>Сервисы</p>
        <li>Apple Music</li>
        <li>Apple TV</li>
        <li>Apple Arcade</li>
        <li>iCloud</li>
        <li>Apple One</li>
        <li>Apple Pay</li>
        <li>Apple Books</li>
        <li>Apple Podcasts</li>
        <li>AppStore</li>
        <p>Учетная запись</p>
        <li>Управление вашим Apple ID</li>
        <li>Учетная запись Apple Store</li>
        <li>iCloud.com</li>
      </ul>

      <ul>
        <p>For education</p>
        <li>Apple in education</li>
        <li>Buy for studing</li>
        <li>iPhone</li>
        <li>Apple Watch</li>
        <li>TV</li>
        <li>Music</li>
        <li>iTunes</li>
        <li>iPadTouch</li>
        <li>Accessories</li>
      </ul>

      <ul>
        <p>For education</p>
        <li>Apple in education</li>
        <li>Buy for studing</li>
        <li>iPhone</li>
        <li>Apple Watch</li>
        <li>TV</li>
        <li>Music</li>
      </ul>

      <ul>
        <p>For education</p>
        <li>Apple in education</li>
        <li>Buy for studing</li>
        <li>iPhone</li>
        <li>Apple Watch</li>
        <li>TV</li>
        <li>Music</li>
        <li>iTunes</li>
        <li>iTunes</li>
      </ul>
    </div>
  );
};

export default Footer;
